import { Button } from '@mui/material'
import React, { useContext } from 'react'
import { useToggle } from 'react-use'

import Icon from 'components/Icon'
import { EditGoldenSignalContext } from 'components/services/create/EditGoldenSignalContext'
import { SaveServiceGoldenSignalDrawer } from 'components/services/create/SaveServiceGoldenSignalDrawer'
import { ServiceGoldenSignal } from 'types/api/services/golden-signal'

export const SaveServiceGoldenSignal: React.FC<{
  disabled?: boolean
  goldenSignal?: ServiceGoldenSignal
  onChanged: (statusCheck: ServiceGoldenSignal, isEdit: boolean) => void
}> = ({ disabled, goldenSignal, onChanged }) => {
  const isEditMode = Boolean(goldenSignal)
  const [isAuthenticationSaved, setIsAuthenticationSaved] = useToggle(false)
  const [isModalOpen, setIsModalOpen] = useToggle(false)

  const {
    getAvailableExternalIntegrations,
    reFetchGoldenSignals,
    setIntegration
  } = useContext(EditGoldenSignalContext)

  const handleClick = () => {
    if (isEditMode) {
      const currentIntegration = getAvailableExternalIntegrations(false).find(
        (integ) => integ?.name === goldenSignal?.integration?.name
      )

      setIntegration(currentIntegration)
    }

    setIsModalOpen(true)
  }

  const handleClose = async () => {
    if (goldenSignal && isAuthenticationSaved) {
      await reFetchGoldenSignals()
    }

    setIsModalOpen(false)
  }

  return (
    <>
      <Button
        color="primary"
        data-testid={
          isEditMode
            ? `edit-service-status-check-${goldenSignal.id}`
            : 'add-edit-team-integration-button'
        }
        disabled={disabled}
        startIcon={<Icon icon={isEditMode ? 'edit' : 'plus'} />}
        variant="contained"
        onClick={handleClick}
      >
        {isEditMode ? 'Edit' : 'Add'}
      </Button>
      <SaveServiceGoldenSignalDrawer
        isOpen={isModalOpen}
        statusCheck={goldenSignal}
        onAuthSave={() => setIsAuthenticationSaved(true)}
        onChanged={onChanged}
        onClose={handleClose}
      />
    </>
  )
}
